import React, { useRef, useMemo, useState, useEffect } from "react";

import { debounce } from "lodash";
import styled from "styled-components";

import { checkPermissionsFor } from "store/storeHelpers";
import { compareObjects } from "utils";
import {
    SMS_TRAFFIC_LIMITS_CREATE_API
} from "const/apiMethods";
import { FilterSectionFlexboxGrid, InsideFormItemsFitWidth, StyledItemAutoMargin } from "components/base/FitContainers";
import TrafficLimitsCreateModal from "./TrafficLimitsCreateModal";
import ServicePlans from "components/Filters/ServicePlans";
import CustomField from "components/Form/CustomField";

import { Alert } from "services/Alert";
import { RadioGroup, Button, CheckPicker, Form, Input, Radio, Schema, SelectPicker, Toggle } from "rsuite";

const { StringType, NumberType } = Schema.Types;


export default ({
    // account, 
    filter,
    service,
    editData,
    setFilter,
    supplierId,
    isSupervisorSms,
    isSupplier,
    isMobile,
    onDataUpdate,
    mccList,
    e212List,
    countryList,
    worldzoneList,
    transitTrunkList,
    subdestinationList,
    suppliersPrefixList,
    destinationList,
    defaultFilter,
    trafficTypeState,
    suppliersGroupList,
    pickedTrunk,

    pickTrunk,
    setEditData,
    setResetToken,
    showCreateModal,
    selectedDefaultData,
    setShowCreateModal,
    setTrafficTypeState,
    getE212DropdownList,
    setSelectedDefaultData,
    getReferencesForReports,
    getSupplierPrefixesDropdown
}) => {

    const [formValue, setFormValue] = useState(defaultFilter);

    const filterInputsRefs = {
        senderid: useRef(null),
        str: useRef(null),
        mcc: useRef(null)
    };

    const isGanGroup = trafficTypeState === "gan_group";
    const isGanNumber = trafficTypeState === "gan";
    const isPrefix = trafficTypeState === "prefix";
    const isMcc = trafficTypeState === "mcc";
    const isDefault = trafficTypeState === "mcc_default";

    const showCreateButton = !isSupervisorSms || isSupervisorSms && checkPermissionsFor(SMS_TRAFFIC_LIMITS_CREATE_API);

    useEffect(() => {
        if (!compareObjects(filter, formValue)) {
            setFormValue(filter);
        }
    }, [filter]);

    useEffect(() => {
        Object.keys(defaultFilter).forEach(key => {
            if (filterInputsRefs && filterInputsRefs[key] && filterInputsRefs[key].current) {
                filterInputsRefs[key].current.value = defaultFilter[key];
            }
        });
        setDefaultLimitState(defaultFilter["default_type_list"]);
    }, [trafficTypeState]);

    const filterModel = isSupplier ? {
        senderid: StringType()
            .maxLength(40, "The maximum is only 40 characters."),
        str: StringType()
            .maxLength(40, "The maximum is only 40 characters."),
        mcc: NumberType()
    } : {
        sp_key: NumberType(),
        wz_key: NumberType(),
        de_key: NumberType(),
        mcc: NumberType()
    };

    const formModel = Schema.Model(filterModel);
    const [defaultLimitState, setDefaultLimitState] = useState(filter?.default_type_list);

    const strFilterPlaceholder = isMcc ? "MCC+MNC, Operator" : "Prefix, GAN Number, GAN Group name";
    const defaultLimitTypeList = [
        {
            value: "supplier",
            name: "Whole account limit"
        },
        {
            value: "mcc_default",
            name: "Default MCC limit"
        }
    ];

    const debouncedSetFilter = useMemo(() =>
        debounce((value) => {
            const filterData = Object.keys(value).reduce((acc, key) => {
                if (value[key] != null) {
                    acc[key] = value[key];
                } else {
                    delete acc[key];
                }
                return acc;
            }, { ...filter });

            setFilter(filterData);
        }, 1000)
        , []);

    return (
        <>
            <StyledForm
                // layout="inline"
                onChange={(value) => {
                    setFormValue(value);

                    debouncedSetFilter(value);
                }}
                formValue={formValue}
                formDefaultValue={defaultFilter}
                model={formModel}
            >
                {isSupplier && <Form.Group controlId="trafficType">
                    <RadioGroup
                        inline
                        name="traffic_type"
                        defaultValue="gan_group"
                        onChange={setTrafficTypeState}
                        value={trafficTypeState}
                    >
                        <Radio value="gan_group">GAN Groups</Radio>
                        <Radio value="gan">GAN Numbers</Radio>
                        {/* <Radio value="prefix">Prefixes</Radio> */}
                        <Radio value="mcc">Operators</Radio>
                        <Radio value="mcc_default">Default limits</Radio>
                    </RadioGroup>

                    {(isGanGroup || isMcc) && <StyledToggle
                        size="lg"
                        checkedChildren="Multi-row edit"
                        unCheckedChildren="Single-row edit"
                        defaultChecked={false}
                        checked={editData.mode === "multiple"}
                        onChange={(check) => {
                            setResetToken((prev) => prev + 1);
                            setEditData((prev) => {
                                return {
                                    ...prev,
                                    mode: check ? "multiple" : "single"
                                }
                            })
                        }}
                    />}
                </Form.Group>}
                <FilterSectionFlexboxGrid controlable={!isMobile}>
                    <InsideFormItemsFitWidth isMobile={isMobile} labelMinWidth={55}>
                        {/* <FormGroup controlId="trunk_type" style={{marginBottom: 0}}> */}
                        {isSupplier && isMcc && <CustomField
                            accepter={SelectPicker}
                            data={transitTrunkList}
                            cleanable={false}
                            searchable={false}
                            valueKey="id"
                            labelKey="name"
                            placeholder="Select trunk"
                            label="Trunk"
                            name="trunk_id"
                            onChange={(id) => {
                                const trunkValue = transitTrunkList.find(trunk => trunk?.id === id);

                                pickTrunk(trunkValue);
                            }}
                            style={{
                                width: 230
                            }}
                        />}
                        {isSupplier
                            ? <>
                                {isDefault && <CustomField
                                    // ref={ref => filterInputsRef["default_type_list"] = ref}
                                    accepter={CheckPicker}
                                    data={defaultLimitTypeList}
                                    value={defaultLimitState}
                                    onChange={setDefaultLimitState}
                                    valueKey="value"
                                    labelKey="name"
                                    name="default_type_list"
                                    placeholder="Limit type"
                                    width={200}
                                    searchable={false}
                                />}
                                {!isMcc && <CustomField
                                    inputRef={filterInputsRefs["senderid"]}
                                    accepter={Input}
                                    // value={filter?.senderid}
                                    placeholder="Sender ID"
                                    name="senderid"
                                    width={200}
                                />}
                                {!isDefault && <CustomField
                                    inputRef={filterInputsRefs["str"]}
                                    accepter={Input}
                                    // value={filter?.str}
                                    placeholder={strFilterPlaceholder}
                                    name="str"
                                    width={360}
                                />}
                                {(isPrefix) && <CustomField
                                    ref={filterInputsRefs["mcc"]}
                                    accepter={SelectPicker}
                                    // value={filter?.mcc}
                                    data={mccList}
                                    labelKey="countryMccName"
                                    valueKey="mcc"
                                    placeholder="Country"
                                    name="mcc"
                                    width={200}
                                />}
                            </>
                            : <>
                                <ServicePlans
                                    cleanable={true}
                                    {...(isMobile ? { style: { marginBottom: "15px" } } : {})}
                                    menuStyle={{ width: 180 }}
                                />
                                <CustomField
                                    accepter={SelectPicker}
                                    labelKey="name"
                                    valueKey="wz_key"
                                    data={worldzoneList}
                                    placeholder="Worldzone"
                                    name="wz_key"
                                    {...(!isMobile ? { width: "200px" } : {})}
                                    menuStyle={{ width: 280 }}
                                />
                                <CustomField
                                    accepter={SelectPicker}
                                    data={destinationList}
                                    labelKey="name"
                                    valueKey="de_key"
                                    placeholder="Destination"
                                    name="de_key"
                                    {...(!isMobile ? { width: "200px" } : {})}
                                    menuStyle={{ width: 280 }}
                                />
                                {service ?
                                    <CustomField
                                        accepter={SelectPicker}
                                        data={subdestinationList}
                                        labelKey="name"
                                        valueKey="sde_key"
                                        placeholder="Subdestination"
                                        name="sde_key"
                                        {...(!isMobile ? { width: "200px" } : {})}
                                        menuStyle={{ width: 320 }}
                                    /> : <CustomField
                                        accepter={SelectPicker}
                                        data={mccList}
                                        labelKey="countryMccName"
                                        valueKey="mcc"
                                        placeholder="Country"
                                        name="mcc"
                                        {...(!isMobile ? { width: "200px" } : {})}
                                        menuStyle={{ width: 320 }}
                                    />}
                            </>}
                        {/* </FormGroup> */}
                    </InsideFormItemsFitWidth>
                    <StyledItemAutoMargin>
                        {isSupplier && !isGanNumber && showCreateButton && <Button
                            appearance="primary"
                            onClick={() => {
                                setShowCreateModal(true);
                            }}
                        >
                            Add new
                        </Button>}
                    </StyledItemAutoMargin>
                </FilterSectionFlexboxGrid>
            </StyledForm>
            <TrafficLimitsCreateModal
                show={showCreateModal}
                supplierId={supplierId}
                onClose={() => {
                    setShowCreateModal(false);
                }}
                onSuccess={() => {
                    onDataUpdate();
                    setShowCreateModal(false);
                    Alert.success("Traffic limit was created");
                }}
                service={service}
                e212List={e212List}
                pickedTrunk={pickedTrunk}
                countryList={countryList}
                title="Traffic limit create modal"
                trafficTypeState={trafficTypeState}
                transitTrunkList={transitTrunkList}
                suppliersGroupList={suppliersGroupList}
                // subdestinationList={subdestinationList}
                suppliersPrefixList={suppliersPrefixList}
                selectedDefaultData={selectedDefaultData}

                pickTrunk={pickTrunk}
                getE212DropdownList={getE212DropdownList}
                setSelectedDefaultData={setSelectedDefaultData}
                getReferencesForReports={getReferencesForReports}
                getSupplierPrefixesDropdown={getSupplierPrefixesDropdown}
            />

        </>
    );
};


const StyledForm = styled(Form)`
    && {
        .rs-form-group {
            display: flex;
            align-items: center;

            margin-bottom: 20px;
            margin-right: 10px;

            .rs-toggle {
                margin-bottom: 0px;
            }
        }

        .rs-radio-group {
            display: inline-block;
        }
    }
`;

const StyledToggle = styled(Toggle)`

    &&.rs-btn-toggle-checked {    
        background-color: var(--color-green);
    }
    &&.rs-btn-toggle-checked:hover {
        background-color: var(--color-green-dark);
    } 
`;
